import { render } from "./ShowMoreLayout.vue?vue&type=template&id=ece88838"
import script from "./ShowMoreLayout.vue?vue&type=script&lang=js"
export * from "./ShowMoreLayout.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__